var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('TmpBlock',{staticClass:"mb-1",attrs:{"height":"20"}}):_c('v-tooltip',{attrs:{"disabled":!_vm.object.tooltip,"z-index":"200","fixed":"","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"filter__label mb-1"},'div',attrs,false),on),[_vm._v(_vm._s(_vm.object.title))])]}}])},[_c('div',[_vm._v(_vm._s(_vm.object.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }